/**
 * AreaSelectionBox — style objects for the Selection box in the Synth VR right sidebar (SRVR-0318,
 * SRVR-0322). Theme tokens only, so the box re-tints with the accent theme.
 */
import type { CSSProperties } from 'react';
import { border, color, font } from '../ui/theme';

export const readoutStyle: CSSProperties = {
  fontFamily: font.sans, fontSize: 11, fontWeight: 600, color: color.ink,
  textAlign: 'center', padding: '4px 0 6px',
  borderBottom: `1px solid ${border.subtle}`, marginBottom: 6,
};

export const readoutEmptyStyle: CSSProperties = { ...readoutStyle, color: color.inkFaint, fontWeight: 500 };

export const groupLabelStyle: CSSProperties = {
  fontFamily: font.sans, fontSize: 10, fontWeight: 700, letterSpacing: 1,
  textTransform: 'uppercase', color: color.inkDim, margin: '6px 0 2px',
};

export const toggleGridStyle: CSSProperties = {
  display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: 6, rowGap: 2,
};

export const toggleRowStyle: CSSProperties = {
  display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer',
  fontFamily: font.sans, fontSize: 11, color: color.inkDim, userSelect: 'none',
};

export const masterRowStyle: CSSProperties = { ...toggleRowStyle, color: color.ink, fontWeight: 600 };

export const checkboxStyle: CSSProperties = { accentColor: color.accent, margin: 0, cursor: 'pointer' };
